import store from "@/store/";
import contractModule from '@/store/modules/contract/index'
import inscriptionService from "@/services/inscriptionService";
import leadService from "@/services/leadService";

export default async ({ from, to, next }) => {
  if(to.params.id !== undefined && to.params.guid !== undefined) {
    console.log('middleware - guid');
    const sub = await inscriptionService.getSubscription(to.params.id, to.params.guid);
    await store.dispatch("subscription/setSubscription", sub)
    await store.dispatch("subscription/setAddressContact", sub)
    await store.dispatch("contract/setContract", sub.contracts[0])
    await store.dispatch("contract/setProductWithContract", sub.contracts[0])

    if(sub.contracts[0].lead_id) {
      let lead = await leadService.get(sub.contracts[0].lead_id);
      await store.dispatch(`consumption/setConsumption`, lead);
    }
    else {
      await store.dispatch(`consumption/setConsumptionWithContract`, sub.contracts[0]);
    }
    // ER-2286: TI contracts must enter the tunnel with the smart-meter flags
    // already on the lead — Offer.vue (which is bypassed when products are
    // forced) is no longer the sole place where the lead is patched.
    await store.dispatch("contract/ensureIncentiveLead", sub.contracts[0].lead_id);
    let contracts = sub.contracts;
    contracts.shift();

    contracts.forEach(async contract => {
      store.commit("subscription/pushContract", contract.id);
      store.registerModule(contract.id, contractModule);
      await store.dispatch(`${contract.id}/setContract`, contract);
    })

    await store.dispatch("common/fillCompletedSteps");
  }

  return next();
}



// WEBPACK FOOTER //
// ./src/router/middleware/guid.js